<template>
  <div class="errors" v-if="$parent.errors">
    <ol>
      <li v-for="(error, field) in $parent.errors" :key="field">
        {{ error[0] }}
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Errors'
}
</script>
